import React from 'react';
import styles from './Header.module.scss';

import HeaderButton from 'components/DetailsComponents/HeaderButton';

import { useMobileViewport } from 'hooks/useMobileViewport';
import { useHistory } from 'react-router-dom';

import {
  MAINTENANCE_REQUEST_EDIT_PATH,
  MAINTENANCE_REQUEST_SUMMARY_PATH
} from 'constants/routeConstants';

import DeleteIcon from '@material-ui/icons/Delete';
import CreateIcon from '@material-ui/icons/Create';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

export const Header = ({ id, onRemove }) => {
  const history = useHistory();
  const isMobile = useMobileViewport();

  if (!id) return null;

  const editPicklist = () => history.push(`${MAINTENANCE_REQUEST_EDIT_PATH}/${id}`);
  const goBack = () => history.push(MAINTENANCE_REQUEST_SUMMARY_PATH);

  const Title = () => <div className={styles.title}>Maintenance Request #{id}</div>;

  return (
    <>
      <div className={styles.header}>
        {!isMobile && <Title />}
        <div className={styles.header__controls}>
          <HeaderButton onClick={editPicklist}>
            <CreateIcon />
            {!isMobile && <span>Edit request</span>}
          </HeaderButton>
          <HeaderButton onClick={onRemove}>
            <DeleteIcon />
            {!isMobile && <span>Remove request</span>}
          </HeaderButton>
          {isMobile && (
            <HeaderButton onClick={goBack}>
              <ChevronLeftIcon />
            </HeaderButton>
          )}
        </div>
      </div>

      {isMobile && <Title />}
    </>
  );
};
